import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ChangeEvent, useRef } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import { getParams } from '@/utils/getParams';

import styles from './Search.module.scss';
import { CustomTextField, EBorderRadius } from '../CustomInput';

interface ISearchProps {
  value: string;
  className?: string;
  onSearch: (params: URLSearchParams) => void;
  onReset: () => void;
}

export const Search: React.FC<ISearchProps> = ({
  value = '',
  className = '',
  onSearch,
  onReset,
}) => {
  const handleSearch = useDebouncedCallback((term: string = '') => {
    const params = getParams({ q: term });

    if (term !== '') {
      params.set('q', term);
    } else {
      params.delete('q');
    }
    onSearch(params);
  }, 300);

  const handleReset = () => {
    if (searchInputRef.current) {
      searchInputRef.current.value = '';
    }
    onReset();
  };

  const searchInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={styles.customInput}>
      <CustomTextField
        inputRef={searchInputRef}
        placeholder="Buscar"
        className={className}
        onChange={(event: ChangeEvent<HTMLInputElement>) =>
          handleSearch(event.target.value)
        }
        onIconClick={handleReset}
        defaultValue={value ?? ''}
        postIcon={value ? faTimes : faSearch}
        borderRadius={EBorderRadius.ROUNDED}
        small
      />
    </div>
  );
};
